import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface MapPlusIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const MapPlusIcon = ({ className, ...props }: MapPlusIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 19L3.78974 20.7368C3.40122 20.8663 3 20.5771 3 20.1675L3 5.43246C3 5.1742 3.16526 4.94491 3.41026 4.86325L9 3M9 19L14.2103 20.7368C14.5988 20.8663 15 20.5771 15 20.1675L15 5.43246C15 5.1742 14.8347 4.94491 14.5897 4.86325L9 3M9 19L9 3"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M15 5L20.2103 3.26325C20.5988 3.13374 21 3.42292 21 3.83246L21 15"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M18.7143 19.6228H20.9797M20.9797 19.6228L23.2451 19.6228M20.9797 19.6228V17.3574M20.9797 19.6228L20.9797 21.8882"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default MapPlusIcon;
